import { Translate, useTranslate } from '~/i18n';
import Container from '~/components/common/container';
import { AngelLeftIcon, AngelRightIcon, VisitSaudi } from '~/svgs/common';
import style from './style.module.css';
import { businessResellerStartBtnEvent } from '~/utils/mixpanel-events/business';

const Partners = () => {
   const { dir, locale } = useTranslate();

   return (
      <div className={`${style['gray-bg']}`}>
         <Container className="grid justify-items-center  px-2  lg:pb-[95px]  ">
            <div className="text-[30px] lg:text-[50px] lg:pt-[40px] py-[20px] lg:py-[95px] text-center font-bold ">
               <Translate id="business:network" />
            </div>
            <div className="lg:hidden">
               <img src="/jarir/map-mobile.png" className="w-full" />
               <div className="bg-jarir-primary text-white py-[32px] px-[27px] rounded-b-xl">
                  <div className="text-[30px] pb-[21px] leading-[35px] font-semibold">
                     <Translate id="business:partnership" />
                  </div>
                  <div className="text-[18px] pb-[21px]  ">
                     <Translate id="business:hala yalla and jarir" />
                  </div>
                  <hr />
                  <div className="grid grid-cols-2 gap-3 pt-[20px]">
                     <div>
                        <div className="text-[30px] font-semibold">1m+</div>
                        <div className="text-[16px]">
                           <Translate id="business:daily website visits" />
                        </div>
                     </div>
                     <div>
                        <div className="text-[30px] font-semibold ltr:text-center">10+</div>
                        <div className="text-[16px] ltr:text-center">
                           <Translate id="business:customers" />
                        </div>
                     </div>
                     <div>
                        <div className="text-[30px] font-semibold">50+</div>
                        <div className="text-[16px] ltr:whitespace-nowrap">
                           <Translate id="business:gcc" />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div className="hidden lg:flex h-[867px]">
               <div className="bg-jarir-primary text-white pt-[67px] px-[40px] ltr:rounded-l-xl  rtl:rounded-r-xl">
                  <div className="text-[40px] xl:text-[50px] pb-[45px] leading-[63px] font-semibold">
                     <Translate id="business:partnership" />
                  </div>
                  <div className="text-[18px] xl:text-[23px] pb-[45px] ">
                     <Translate id="business:hala yalla and jarir" />
                  </div>
                  <hr />
                  <div className="grid grid-cols-3 gap-3 pt-[40px]">
                     <div>
                        <div className="text-[34px] font-semibold">1m+</div>
                        <div>
                           <Translate id="business:daily website visits" />
                        </div>
                     </div>
                     <div>
                        <div className="text-[34px] font-semibold">10m+</div>
                        <div>
                           <Translate id="business:customers" />
                        </div>
                     </div>
                     <div>
                        <div className="text-[34px] font-semibold">50+</div>
                        <div>
                           <Translate id="business:gcc" />
                        </div>
                     </div>
                  </div>
               </div>
               <img src="/jarir/map.png" className="lg:w-7/12 rtl:rounded-l-3xl" />
            </div>
            <div className="lg:flex mt-6 w-full">
               <div className="bg-white items-center p-12 text-[#00983F] lg:flex-grow h-[289px]  rounded-3xl lg:ltr:mr-4 lg:rtl:ml-4">
                  <div className="flex flex-col lg:flex-row">
                     <div className="text-[30px] lg:text-[40px] font-semibold leading-[35px] lg:leading-[45px]">
                        <div className="lg:w-8/12 lg:pt-5">
                           <Translate id="business:key startegic" />
                        </div>
                     </div>
                     <div className="transform ltr:-translate-x-10 rtl:translate-x-10 lg:pt-5">
                        <VisitSaudi className="py-6 lg:p-0" />
                     </div>
                  </div>
               </div>
               <div className="bg-[#0552Bc] text-[20px] text-white lg:w-[379px] h-[289px] rounded-3xl p-12  lg:p-8  mt-3 lg:mt-0  mb-8 relative">
                  <Translate id="business:apply as reseller" />
                  <div className="text-[25px]  font-semibold  absolute bottom-7">
                     <a
                        href={`https://pro.halayalla.com/${locale}/reseller/signup?utm_source=halayalla.com&utm_medium=referral`}
                        className="flex reseller-startnow"
                        onClick={() => businessResellerStartBtnEvent()}>
                        <Translate id="business:start now" />
                        <div className="rtl:pt-1 ltr:pt-2">
                           {dir === 'rtl' ? <AngelLeftIcon /> : <AngelRightIcon />}
                        </div>
                     </a>
                  </div>
               </div>
            </div>
         </Container>
      </div>
   );
};
export default Partners;
